export default __webpack_public_path__ + "static/media/RedFish.48cb0b66.png";